import Gallery, { GalleryItem } from "../components/ProjectGallery";
import HeaderSubPages from "../components/HeaderSubPages";
import '../assets/css/Projects.css'
import sunIcon from '../assets/graphics/FSV_graphic-logosunwhite.png'
import galleryImage01 from '../assets/graphics/SVR_Winter_Lift_Projects_Flying_Squirrel_Seattle_Ridge_01.jpg'
import galleryImage02 from '../assets/graphics/SVR_Winter_Lift_Projects_Flying_Squirrel_Seattle_Ridge_02.jpg'
import galleryImage03 from '../assets/graphics/SVR_Winter_Lift_Projects_Flying_Squirrel_Seattle_Ridge_03.jpg'
import galleryImage04 from '../assets/graphics/SVR_Winter_Lift_Projects_Flying_Squirrel_Seattle_Ridge_04.jpg'

const galleryImages = [
  { caption: "Christmas Lift will resemble the current Flying Squirrel Lift", url: galleryImage01, alt: "Christmas Lift will resemble the current Flying Squirrel Lift" },
  { caption: "Christmas Lift will resemble the current Flying Squirrel Lift", url: galleryImage02, alt: "Christmas Lift will resemble the current Flying Squirrel Lift" },
  { caption: "Lookout Express Lift will resemble the current Seattle Ridge Lift", url: galleryImage03, alt: "Lookout Express Lift will resemble the current Seattle Ridge Lift" },
  { caption: "Lookout Express Lift will resemble the current Seattle Ridge Lift", url: galleryImage04, alt: "Lookout Express Lift will resemble the current Seattle Ridge Lift" }
];

function ProjectsLookout() {
  return (
    <div className='projects'>
      <div className="projects-header-lookout">
        <HeaderSubPages />
      </div>
      <div className="projects-subheader">
        <h2>Lookout and Christmas Lift Replacement</h2>
        <div className="main-text">
          <p>Sun Valley resort has received approval from the U.S. Forest Service and the Bureau of Land Management to move forward with the replacement of Christmas Lift and Lookout Express Lift on Bald Mountain. Work will commence starting in April 2026 to replace Lookout Express with a high speed detachable six-person lift and Christmas Lift with a high-speed detachable quad. These replacements will increase reliability and uphill capacity while continuing the modernization of Sun Valley’s industry-leading lift infrastructure. </p>
        </div>
      </div>
      <div className='hero-quote'>
        <div className='hero-quote-text'>
          <h2 className='quote1'>"</h2>
          <p>The replacement of Christmas and Lookout Express lifts is another major milestone in modernizing the lift network at Sun Valley. Both lifts play a critical role in getting skiers and riders to the top of Bald Mountain. We are proud to partner with Doppelmayr once again and build on the success of our most recent lift projects – Seattle Ridge, Flying Squirrel, Challenger and Broadway. Sun Valley has the most efficient lift system in the country, and these upgrades will ensure that continues for many years to come.</p>
          <h2 className='quote2'>"</h2>
        </div>
        <h4>– Pete Sonntag, Chief Operating Officer of Sun Valley Resort</h4>
        <br />
      </div>
      <div className="project-highlights-container">
        <div className="gold-line"></div>
        <div className='project-highlights' id="progress">
          <ul>
            <li><span className="bold">Lookout Express Replacement.</span> The detachable quad lift will be replaced with a new six-person lift, cutting ride time to approximately 8.5 minutes at speeds up to 1,000 feet per minute.</li>
            <li><span className="bold">Christmas Lift Replacement.</span> The detachable quad will be replaced with a new high-speed detachable quad, offering an approximate 4.5-minute ride time at speeds up to 1,000 feet per minute.</li>
            <li><span className="bold">Trail and Environmental Enhancements.</span> Construction on the new Connector Trail, in conjunction with the City of Ketchum's connection of River Run (via Bald Mountain Trail) to Warm Springs, has also been approved and is slated to begin in the spring of 2026.</li>
          </ul>
          <div className="project-highlights-image">
            <img src={sunIcon} alt="sun valley sun icon"></img>
          </div>
        </div>
        <Gallery>
          <GalleryItem><img src={galleryImages[0].url} alt={galleryImages[0].alt}></img><p>{galleryImages[0].caption}</p></GalleryItem>
          <GalleryItem><img src={galleryImages[1].url} alt={galleryImages[1].alt}></img><p>{galleryImages[1].caption}</p></GalleryItem>
          <GalleryItem><img src={galleryImages[2].url} alt={galleryImages[2].alt}></img><p>{galleryImages[2].caption}</p></GalleryItem>
          <GalleryItem><img src={galleryImages[3].url} alt={galleryImages[3].alt}></img><p>{galleryImages[3].caption}</p></GalleryItem>
        </Gallery>
        <div className="progressupdates-title">
          <ul>
            <li>Progress Updates</li>
          </ul>
        </div>
      </div>
      <div className="progressupdates">
        <div className="progressupdates-container">
          <div class="progress-video">
            <iframe src="https://www.youtube.com/embed/7yThHS-fvbQ?si=p_ou5BCAyTWc1acH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
          <div className="progress-link">
            <a href='/progress/lookoutchristmaslifts'>MORE UPDATES</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectsLookout;
